/**
 * Size Tokens - Layout widths, column counts, and icon box sizes (Figma S/M/L)
 */

export const sizes = {
  0: { value: '0px' },
  full: { value: '100%' },
  /** Figma icon glyph box: S 16px, M 18px, L 24px */
  icon: {
    s: { value: '16px' },
    m: { value: '18px' },
    l: { value: '24px' },
  },
  layout: {
    xs: { value: '360px' },
    s: { value: '768px' },
    m: { value: '1024px' },
    l: { value: '1440px' },
  },
  columns: {
    s: { value: '8' },
    m: { value: '12' },
  },
};
